import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n";
import { Button } from "../components/ui";

export default function NotFound() {
  const { tx } = useI18n();
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12, background: "var(--bg)" }}>
      <div style={{ fontSize: 60, fontWeight: 900, color: "var(--c-indigo-600)" }}>404</div>
      <div className="u-muted">{tx("ไม่พบหน้าที่คุณต้องการ", "Page not found")}</div>
      <Link to="/"><Button variant="primary">{tx("กลับหน้าแรก", "Back to home")}</Button></Link>
    </div>
  );
}
